export default class Paging {
    constructor(el) {
        this.el = el;

        if (!this.el) return;
        
        this.items = this.el.querySelectorAll('a[href]');
        this.items.forEach(item => {
            item.addEventListener('click', this.page.bind(this));
        });
    }

    page(e) {
        e.preventDefault();

        const url = new URL(e.currentTarget.href);
        const searchParams = new URLSearchParams(url.search);
        const page = searchParams.get('page') || 1;

        const event = new CustomEvent('onPage', { detail: { page: parseInt(page, 10) }});
        
        this.el.dispatchEvent(event);
    }
}